import { render, staticRenderFns } from "./2020.vue?vue&type=template&id=97b9f4f2"
import script from "./2020.vue?vue&type=script&lang=js"
export * from "./2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports